'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _SearchOutlined = _interopRequireDefault(require('./lib/icons/SearchOutlined'));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

var _default = _SearchOutlined;
exports.default = _default;
module.exports = _default;